// this function returns:
// - undefined if the route is valid or if it's impossible to check right now
//   and the check should be run again after initial data is loaded
// - a new route object if the route is invalid and should be changed
//
// This signature is a bit unusual, but it's like that to fit the argument of router.beforeEach `next` callback
export default async function (route, store) {
  // without initial data being loaded, we can't know if the chatScope and chat params in the route are valid
  if (!store.getters.isInitialDataLoaded) {
    return undefined
  }

  // all chat scopes are loaded during the initial data load so we can just check if the chatScope route param is valid
  const isValidChatScope = route.params.chatScope && !!store.getters.getChatScopeByPath(route.params.chatScope)
  const defaultChatScope = store.getters.getDefaultChatScope
  if (!isValidChatScope && route.params.chatScope !== defaultChatScope) {
    return { path: '/' + defaultChatScope }
  }

  // a valid chat scope and no chat chosen is a valid route
  if (!route.params.chat) {
    return undefined
  }

  const isChatAlreadyLoaded = !!store.getters.getChatPartnerId(route.params.chatScope, route.params.chat)
  if (isChatAlreadyLoaded) {
    return undefined
  }

  // not all chats are initially loaded into the store because there might be thousands of them
  // so to know if a chat is valid, we need to ask the backend
  const freshlyLoadedChat = await store.dispatch('fetchChat', {
    scopePath: route.params.chatScope,
    chatPath: route.params.chat
  })

  if (!freshlyLoadedChat) {
    // chosen chat scope is valid, but the chosen chat doesn't exist, so we just redirect to the chat scope
    return { path: '/' + route.params.chatScope }
  }

  return undefined
}
